import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment"
import { toast } from "react-toastify";
import { getUserSelector } from "../../../../../../../../../redux/reducers/reducerSlices/UserReducer";
import { CustomDynamicForm } from "../../../../../../../Common/CustomForm/CustomDynamicForm";
import { AppConstant } from "../../../../../../../../Assests/AppConstant";
import { sagaActions } from "../../../../../../../../../sagas/sagaActions";
import { showAlert, initiateSearch, sortArrByKey, shouldHavePermission } from "../../../../../../../../Assests/Utility";
import { getCSCEselector } from "../../../../../../../../../redux/reducers/reducerSlices/CSCEReducer";
import Popup from "../../../../../../../Common/Popup/Popup";
import CSCEConfigList from "../CSCEConfigList/CSCEConfigList";

const CSCEConfigAdminScreen = (props) => {
  const { themeSelected } = props;
  const [loading, setLoading] = useState(false);
  const [loaderId, setLoaderId] = useState({ loading: false, id: '' });
  const [editData, setEditData] = useState({});
  const [searchStr, setSearchStr] = useState('');
  const dispatch = useDispatch();
  const user = useSelector(getUserSelector);
  const { permissions } = user;
  const { appConfigList, appConfigDetailsLoader, responseObject } = useSelector(getCSCEselector);
  const [appConfigListData, setAppConfigListData] = useState([]);

  useEffect(() => {
    getCSCEConfigDetails();
  }, []);

  useEffect(() => {
    if (appConfigList) {
      setAppConfigListData(appConfigList);
    }
  }, [appConfigList]);

  useEffect(() => {
    if (responseObject) {
      setShowModal(false)
      getCSCEConfigDetails()
      // dispatch({ type: sagaActions.CLEAR_CSCE_CONFIG_DETAILS })
    }
  }, [responseObject])

  const getCSCEConfigDetails = () => {
    dispatch({ type: sagaActions.CSCE_CONFIG_DETAILS, payload: { "action": 'read' } });
  }

  let formFieldList = [
    {
      name: "AppIdentifier",
      type: "text",
      size: "col-sm-6",
      position: 1,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.appIdentifier,
      formValidation: {
        required: true,
      },
      disabledField: Object.keys(editData).length ? true : false
    },
    {
      name: "AppName",
      type: "text",
      size: "col-sm-6",
      position: 2,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.appName,
      formValidation: {
        required: true,
      },
    },
    /**,
    {
      name: "StartTime",
      type: "text",
      size: "col-sm-6",
      position: 3,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.startTime,
      formValidation: {
        required: false,
        allowOnlyNumber: true,
        lengthValidation: {
          minLength: 1,
          maxLength: 6,
          customError: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.zipCodeErrorMessage
        },
      },
    },
    {
      name: "EndTime",
      type: "text",
      size: "col-sm-6",
      position: 4,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.endTime,
      formValidation: {
        required: false,
        allowOnlyNumber: true,
        lengthValidation: {
          minLength: 1,
          maxLength: 6,
          customError: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.zipCodeErrorMessage
        },
      },
    },
    */
    {
      name: "PrimaryBrandingColour",
      type: "text",
      size: "col-sm-6",
      position: 3,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.primaryBrandingColour,
      formValidation: {
        required: true,
      },
    },
    {
      name: "SecondaryBrandingColour",
      type: "text",
      size: "col-sm-6",
      position: 4,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.secondaryBrandingColour,
      formValidation: {
        required: true,
      },
    },
    {
      name: "PrimarTextColour",
      type: "text",
      size: "col-sm-6",
      position: 5,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.primarTextColour,
      formValidation: {
        required: true,
      },
    },
    {
      name: "SecondaryTextColour",
      type: "text",
      size: "col-sm-6",
      position: 6,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.secondaryTextColour,
      formValidation: {
        required: true,
      },
    },
    {
      name: "BadgeColour",
      type: "text",
      size: "col-sm-6",
      position: 7,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.badgeColour,
      formValidation: {
        required: true,
      },
    },
    {
      name: "DisableDescription",
      type: "textarea",
      size: "col-sm-6",
      position: 8,
      title:
        AppConstant.CSCEAppConfig.csceAppconfigDetails.disableDescription,
      formValidation: {
        required: true,
      },
    }
  ];

  const getSummitedFormData = (data) => {
    if (editData && editData.AppIdentifier) {
      data.AppIdentifier = editData.AppIdentifier;
      data.action = "update";
      data.UpdatedOn = moment(new Date()).format('YYYY-MM-DD hh:mm');
      data.UpdatedBy = user.cu_id;
      dispatch({ type: sagaActions.CSCE_CONFIG_DETAILS, payload: data });
    } else {
      data.action = "create";
      data.CreatedOn = moment(new Date()).format('YYYY-MM-DD hh:mm');
      data.CreatedBy = user.cu_id;
      data.AppStatus = true;
      dispatch({ type: sagaActions.CSCE_CONFIG_DETAILS, payload: data });

    }
  };

  const editClicked = (data) => {

    let editData1 = {
      "AppIdentifier": data.AppIdentifier,
      "AppName": data.AppName,
      // "StartTime": data.StartTime,
      // "EndTime": data.EndTime,
      "PrimaryBrandingColour": data.PrimaryBrandingColour,
      "SecondaryBrandingColour": data.SecondaryBrandingColour,
      // "wh_date_activated": moment(data.DateActivated).format('YYYY-MM-DD hh:mm'),
      "PrimarTextColour": data.PrimarTextColour,
      "SecondaryTextColour": data.SecondaryTextColour,
      "BadgeColour": data.BadgeColour,
      "DisableDescription": data.DisableDescription
      // "is_branding": data.IsBranding?.toString()
    }
    setEditData(editData1);
    setShowModal(true);
  }

  const disableAction = (data) => {
    setLoading(true);
    let updateData = {
      ...data,
      action: "update",
      UpdatedOn: moment(new Date()).format('YYYY-MM-DD hh:mm'),
      UpdatedBy: user.cu_id,
      AppStatus: !data.AppStatus,
    };

    dispatch({ type: sagaActions.CSCE_CONFIG_DETAILS, payload: updateData });
  };

  const onDeleteClicked = (data) => {
    setLoading(true);
    let deleteData = {
      AppIdentifier: data.AppIdentifier,
      action: "delete",
    }

    dispatch({ type: sagaActions.CSCE_CONFIG_DETAILS, payload: deleteData });
  }

  const [showModal, setShowModal] = useState(false);
  const closepopup = () => {

    setEditData({});
    setShowModal(false);
  }
  const submitbtnData = {
    show: true,
    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm
      .saveButtonTitle,
  };
  const cancelbtndata = {
    show: true,
    text: AppConstant.comments.resetbutton,
  };
  const createForm = () => {
    return (
      <CustomDynamicForm
        formFieldList={formFieldList}
        sort={true}
        cancelBtn={cancelbtndata}
        submitbtn={submitbtnData}
        themeSelected={themeSelected}
        getSummitedFormData={getSummitedFormData}
        // getFormFieldData={getFormFieldData}
        editFormData={editData}
        loading={appConfigDetailsLoader}

      />
    );
  };

  const popupObj = {
    id: "CreateAppConfigFormPopup1",
    modalLabel: "CreateAppConfigFormPopup1",
    showClose: true,
    showfooter: true,
    showHeader: true,
    sendDriverNotification: false,
    modalSize: "xl",
    title: Object.keys(editData).length ? AppConstant.commonStrings.edit :
      AppConstant.commonStrings.create,
    bodyText: createForm(),
    subText: "",
    keyboard: false,
    backdrop: "static",
    footerBtn: {
      btn1: {
        show: true,
        text: AppConstant.comments.cancelCommentButtonTitle,
      },
      btn2: {
        show: true,
        text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm
          .saveButtonTitle,
      },
    },
  };



  return (
    <div className="pt-2">

      <div className='container-fluid d-flex py-2 text-start justify-content-between'>
        <button
          className={'addButton'}
          // disabled={allowPermissionC ? '' : 'disabled'}
          onClick={() => setShowModal(true)}
        >
          {
            AppConstant.commonStrings.create
          }
        </button>
        {/* <div className='w-25'>
          <WarehouseSearch
            placeholder={'Search Warehouses'}
            inputValue={searchStr}
            cancelSearch={() => setSearchStr('')}
            onChangeHandler={(text) => setSearchStr(text)} />
        </div> */}
      </div>

      <div className="roleListTable mt-1">
        <CSCEConfigList propsObj={props} userObj={user} editClicked={editClicked}
          disableAction={disableAction} themeSelected={themeSelected} deleteClicked={onDeleteClicked} />
        <Popup
          {...popupObj}
          showModal={showModal}
          showfooter={false}
          closepopup={closepopup}
          themeSelected={themeSelected}

        />
      </div>
    </div>
  );
};

export default CSCEConfigAdminScreen;
